import type { ReactNode } from 'react'

/**
 * The top of every console screen: what surface this is, in small caps over a
 * serif line, with the screen's own controls on the right.
 *
 * The eyebrow is the only place the console shouts, and it is doing the one
 * job caps are good at — labelling a surface rather than saying a sentence.
 */
export function PageHeader({
  eyebrow,
  title,
  children,
}: {
  readonly eyebrow: string
  readonly title: string
  readonly children?: ReactNode
}) {
  return (
    <div className="mb-5 flex flex-wrap items-end justify-between gap-3">
      <div>
        <div className="st-eyebrow mb-1">{eyebrow}</div>
        <h1 className="st-display text-3xl">{title}</h1>
      </div>
      {children ? <div className="print-hide flex flex-wrap items-center gap-2">{children}</div> : null}
    </div>
  )
}
